import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changePayments } from '../../redux/quoteSlice';
import getPaymentsInfos from '../../helpers/getPaymentsInfos';
import Flex from './PaymentDescribe/Flex';
import PaymentType from './PaymentType/PaymentType';
import CreditCardWithEntry from './PaymentDescribe/CreditCardWithEntry';
import CreditCardNoEntry from './PaymentDescribe/CreditCardNoEntry';
import Pravaler from './PaymentDescribe/Pravaler';

function Payment() {
  const dispatch = useDispatch();
  const reduxState = useSelector((state) => state);
  const {
    quote: { id, hash },
    payments: {
      totalDiscountPercentage,
      iepayment,
    },
  } = reduxState;

  const requestPayments = async () => {
    getPaymentsInfos(id, hash).then((info) => dispatch(changePayments(info)));
  };

  useEffect(() => {
    requestPayments();
  }, []);

  return (
    <section>
      <table className="top-division-border bottom-division-border">
        <tbody>
          {(!iepayment || (iepayment && iepayment.poupancinha === 1)) && (
            <>
              <tr style={{ height: `${170 + (1 * 24)}px` }} className="display-block-left">
                <PaymentType
                  type="POUPANCINHA"
                  contribution="Flexível"
                  margin={((170 + (1 * 24) - 99) / 2)}
                />
              </tr>
              <tr style={{ height: `${170 + (1 * 24)}px` }} className="display-block-right">
                <Flex />
              </tr>
            </>
          )}
          {(!iepayment || (iepayment && iepayment.cartaoEntrada === 1)) && (
            <>
              <tr style={{ height: `${165 + (1 * 24)}px` }} className="display-block-left info-table-row">
                <PaymentType
                  type="CARTÃO DE CRÉDITO"
                  contribution="Com Entrada"
                  margin={((165 + (1 * 24) - 99) / 2)}
                />
              </tr>
              <tr style={{ height: `${165 + (1 * 24)}px` }} className="display-block-right">
                <CreditCardWithEntry />
              </tr>
            </>
          )}
          {(!iepayment || (iepayment && iepayment.parcelado === 1)) && (
            <>
              <tr style={{ height: `${130 + (1 * 24)}px` }} id="card" className="display-block-left info-table-row">
                <PaymentType
                  type="CARTÃO DE CRÉDITO"
                  contribution="Sem Entrada"
                  margin={((130 + (1 * 24) - 99) / 2)}
                />
              </tr>
              <tr style={{ height: `${130 + (1 * 24)}px` }} className={`display-block-right ${totalDiscountPercentage === 0 ? 'no-discount-print-margin' : ''}`}>
                <CreditCardNoEntry />
              </tr>
            </>
          )}
          {(!iepayment || (iepayment && iepayment.pravaler === 1)) && false && (
            <>
              <tr style={{ height: `${120 + (1 * 24)}px` }} id="card" className="display-block-left info-table-row">
                <PaymentType
                  type="PRAVALER"
                  contribution="Sem Entrada"
                  margin={((120 + (1 * 24) - 99) / 2)}
                />
              </tr>
              <tr style={{ height: `${120 + (1 * 24)}px` }} className="display-block-right no-discount-print-margin">
                <Pravaler />
              </tr>
            </>
          )}
        </tbody>
      </table>
      <div className="pagebreak"> </div>
    </section>
  );
}

export default Payment;
